import { render, staticRenderFns } from "./centre.vue?vue&type=template&id=490f9911&scoped=true&"
import script from "./centre.vue?vue&type=script&lang=js&"
export * from "./centre.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490f9911",
  null
  
)

export default component.exports